import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SafetyFieldName } from '@app/pages/kpi-data-mgmt/safety/safety.constant';
import { Status } from '@app/shared/enums';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { DynamicPipe } from '@app/shared/pipes/dynamic-pipe';

@Component({
  selector: 'app-safety-data-grid-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, TranslateModule, DynamicPipe],
  template: `
  @if(data[field] === ''){
    <div></div>
  }
  @else {
    @switch (field) {
      @case (safetyFieldName.emIncidentURL){
        <a [href]="data[field]" target="_blank">{{'ml_143965' | translate}}</a>
      }
      @case (safetyFieldName.status){
        @if(data[field]===status.INACTIVE) {
        <mat-checkbox disabled [checked]="true"></mat-checkbox>
        }
      }
      @default {
        <div [innerHtml]="data[field] | dynamicPipe: column.pipe: column.pipeArgs"></div>
      }
    }
  }

  `
})
export class SafetyDataGridCell implements OnInit {
  @Input() data: any;
  @Input() field: string;
  @Input() column: any;

  status = Status;
  safetyFieldName = SafetyFieldName;

  constructor() { }

  ngOnInit() { }


}
